// extracted by mini-css-extract-plugin
module.exports = {"screenloop":"styles-module__screenloop___7OHCg"};